import { render } from "./QuizFailed.vue?vue&type=template&id=44c77187&scoped=true&ts=true"
import script from "./QuizFailed.vue?vue&type=script&lang=ts"
export * from "./QuizFailed.vue?vue&type=script&lang=ts"

import "./QuizFailed.vue?vue&type=style&index=0&id=44c77187&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c77187"]])

export default __exports__